import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const docs = {
  waiver: {
    title: "Coaching Waiver & Release of Liability",
    body: [
      "By participating in any coaching, training, or nutrition program offered by Howell Transformations (\"Coach\"), you acknowledge that physical exercise and dietary changes carry inherent risks, including but not limited to injury, illness, or aggravation of pre-existing conditions.",
      "You confirm that you are voluntarily participating and are in adequate health to engage in physical activity. You should consult a physician before beginning any fitness or nutrition program.",
      "You assume full responsibility for any risks, injuries, or damages, known or unknown, that you might incur as a result of participating. You release and hold harmless Howell Transformations and Ryan Howell from any and all liability, claims, or demands arising from your participation.",
      "All coaching guidance is educational in nature and is not a substitute for professional medical advice, diagnosis, or treatment.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "By purchasing or applying for any program, you agree to these Terms. Programs, pricing, and services are described on this website and are subject to change.",
      "One-time products (workout programs, nutrition blueprints) are delivered digitally and are non-transferable. Ongoing coaching requires active enrollment and adherence to the agreed schedule.",
      "In-person training requires a valid membership to the designated training gym, obtained and maintained by the client. Sessions are by appointment and subject to availability.",
      "You agree to provide accurate information and to use all programs at your own risk. Results vary between individuals and are not guaranteed.",
      "Howell Transformations reserves the right to decline or discontinue service at its discretion.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "Howell Transformations collects the information you provide through application forms, check-ins, and communications (such as name, email, phone, and progress details) solely to deliver and improve coaching services.",
      "Your information is never sold. It is used to contact you, personalize your coaching, and track your progress. Progress photos and check-in data are kept confidential and used only for coaching purposes.",
      "Form submissions may be processed by trusted third-party services (such as email delivery) strictly to notify the Coach of your inquiry.",
      "You may request access to or deletion of your personal data at any time by contacting the Coach.",
    ],
  },
  cancellation: {
    title: "Cancellation Policy",
    body: [
      "In-person sessions require a minimum of 24 hours' notice to cancel or reschedule. Sessions cancelled with less notice, or missed without notice, are forfeited.",
      "Clients arriving more than 15 minutes late may have their session shortened or counted as completed.",
      "Monthly coaching packages may be discontinued at the end of any billing period after the minimum commitment has been met. Prorated refunds are not provided for partial periods.",
      "Digital one-time products are non-refundable once delivered, as they are custom-created for you.",
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const navigate = useNavigate();
  const content = docs[doc] || docs.terms;

  return (
    <div className="min-h-screen bg-[#0A0A0A] py-16 px-6">
      <div className="max-w-3xl mx-auto">
        <button onClick={() => navigate("/")} data-testid="legal-back" className="inline-flex items-center gap-2 text-sm text-[#A3A3A3] hover:text-white mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to site
        </button>
        <span className="text-xs uppercase tracking-[0.25em] text-[#0055FF] font-bold">Howell Transformations</span>
        <h1 data-testid="legal-title" className="font-display font-semibold uppercase tracking-tight text-white text-3xl sm:text-4xl mt-3">{content.title}</h1>
        <div className="mt-8 space-y-5">
          {content.body.map((p, i) => (
            <p key={i} className="text-[#A3A3A3] leading-relaxed">{p}</p>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-[#262626] flex flex-wrap gap-4 text-xs uppercase tracking-widest">
          {Object.keys(docs).map((k) => (
            <button key={k} data-testid={`legal-link-${k}`} onClick={() => navigate(`/legal/${k}`)} className={`transition-colors ${k === doc ? "text-[#0055FF] font-bold" : "text-[#A3A3A3] hover:text-white"}`}>
              {docs[k].title.split(" ")[0]}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
